export default __webpack_public_path__ + "static/084-a84d770d48b9f688c817ad7b93d5d4ed.jpg";